import { Box, Checkbox, Divider, Typography } from "@mui/material";
import useColors from "../../../../../../../../../api/hooks/useColors";
import MisconfigurationRow from "./MisconfigurationRow";

export const getMisconfigurationChecked = (
  fullMisconfig,
  selectedEntityIDsMapping
) => {
  if (!Object.keys(selectedEntityIDsMapping).includes(fullMisconfig.entity_id))
    return false;
  else {
    return fullMisconfig.affected_entity_ids.every((entityId) =>
      selectedEntityIDsMapping[fullMisconfig.entity_id].includes(entityId)
    );
  }
};

export default function GroupedControlEntitiesSelection({
  fullControl,
  rowByEntityId,
  selectedEntityIDsMapping,
  setSelectedEntityIDsMapping,
}) {
  const colors = useColors();

  const allChecked = fullControl.misconfigurations
    .filter((fullMisconfig) => !fullMisconfig.is_excluded)
    .map((fullMisconfig) => {
      return getMisconfigurationChecked(
        fullMisconfig,
        selectedEntityIDsMapping
      );
    })
    .every((checked) => checked);

  const handleCheckAllChange = () => {
    if (allChecked) setSelectedEntityIDsMapping({});
    else {
      const mapping = fullControl.misconfigurations.reduce(
        (acc, fullMisconfig) => {
          acc[fullMisconfig.entity_id] = fullMisconfig.affected_entity_ids;
          return acc;
        },
        {}
      );
      setSelectedEntityIDsMapping(mapping);
    }
  };

  return (
    <Box
      border={"1px solid " + colors.grey_20percent}
      borderRadius="10px"
      display="flex"
      flexDirection="column"
      padding="4px 8px 8px 8px"
      sx={{ backgroundColor: colors.common_white }}
    >
      <Box display="flex" alignItems="center" paddingLeft="8px">
        <Box width="50px" display="flex" justifyContent="center">
          <Checkbox
            checked={allChecked}
            size="small"
            sx={{
              color: colors.primary_main,
              "&.Mui-checked": {
                color: colors.primary_main,
              },
            }}
            onChange={handleCheckAllChange}
          />
        </Box>
        <Box width="50px"></Box>
        <Box width="100px" display="flex" justifyContent="center">
          <Typography variant="overline" color={colors.text_primary}>
            Type
          </Typography>
        </Box>
        <Box width="100px" display="flex" justifyContent="center">
          <Typography variant="overline" color={colors.text_primary}>
            Name
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ borderColor: colors.divider }} />
      <Box
        display="flex"
        flexDirection="column"
        maxHeight="320px"
        overflow="auto"
      >
        {fullControl.misconfigurations.map((fullMisconfig) => (
          <MisconfigurationRow
            key={fullMisconfig.misconfiguration_id}
            fullMisconfiguration={fullMisconfig}
            rowByEntityId={rowByEntityId}
            selectedEntityIDsMapping={selectedEntityIDsMapping}
            setSelectedEntityIDsMapping={setSelectedEntityIDsMapping}
          />
        ))}
      </Box>
    </Box>
  );
}
